import { mutateAllFpCartRequestCache } from '@hooks-api/fortune/useApiFpCartRequestCache'
import { useCallback } from 'react'
import { useStmResetAllCarts } from './use-stm-reset-all-carts'
import { useStmSyncCartSessionStore } from './use-stm-sync-cart-session-to-store'

/**
 * 後端整批覆蓋所有品牌購物車後，本機三層快取全部過期，要一起清才會重新從 session 抓：
 * cart_request_cache 是 immutable SWR，不清 cache 不會再發請求；
 * 同步集合每個 campaign 只同步一次，不重設會跳過寫回；
 * 本機 cart store 的商品是舊清單，重設後由購物車頁掛載時的同步補回。
 */
export const useStmInvalidateCartSessions = () => {
  const { resetAllCarts } = useStmResetAllCarts()

  const invalidateCartSessions = useCallback(async () => {
    await mutateAllFpCartRequestCache?.(undefined, { revalidate: false })
    useStmSyncCartSessionStore.getState().resetSyncedCampaignCodes()
    resetAllCarts()
  }, [resetAllCarts])

  return { invalidateCartSessions }
}
